import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgHideIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#79869F"
        fillRule="evenodd"
        d="M3 16s3 10 13 10 13-10 13-10S26 6 16 6 3 16 3 16m2.126 0a15.202 15.202 0 0 0 2.185 3.75C9.049 21.922 11.772 24 16 24s6.952-2.079 8.688-4.25A15.2 15.2 0 0 0 26.874 16a15.201 15.201 0 0 0-2.185-3.75C22.951 10.078 20.228 8 16 8c-4.228 0-6.952 2.079-8.688 4.25A15.2 15.2 0 0 0 5.126 16"
        clipRule="evenodd"
      />
      <path
        fill="#79869F"
        fillRule="evenodd"
        d="M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
        clipRule="evenodd"
      />
      <path
        fill="#79869F"
        fillRule="evenodd"
        d="m6.226 26.367 18-22 1.548 1.266-18 22z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgHideIcon;
